import {
	ADD_AP_GROUP_SSID,
	ADD_AP_GROUP_SSID_COMPLETE,
	AP_GROUP_SSID_ADD_TRIGGER,
	DELETE_AP_GROUP_SSID_FAIL,
	DELETE_AP_GROUP_SSID_SUCCESS,
	EDIT_AP_GROUP_SSID,
	EDIT_AP_GROUP_SSID_COMPLETE,
	GET_AP_GROUP_SSID_LIST,
	GET_AP_GROUP_SSID_LIST_FAIL,
	GET_AP_GROUP_SSID_LIST_SUCCESS,
	OPEN_AP_GROUP_SSID_MODAL,
	RESET_ADD_AP_GROUP_SSID,
} from '../constants/ssid/apGroupSSIDConstants';

/**
 * Reducer function for managing ssid list state.
 *
 * This reducer handles actions related to fetching ssid data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the ssid list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const apGroupSSIDReducer = (
	state = {
		apGroupSsidList: {},
		editApGroupSSID: false,
		addApGroupSSIDResp: null,
		editApGroupSSIDData: {},
		editRow: null,
		deleteSuccessMessage: null,
		deleteFailMessage: null,
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case GET_AP_GROUP_SSID_LIST:
			return {
				...state,
				loading: true,
			};
		case GET_AP_GROUP_SSID_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				apGroupSsidList: action.payload,
			};
		case GET_AP_GROUP_SSID_LIST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case OPEN_AP_GROUP_SSID_MODAL:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case ADD_AP_GROUP_SSID:
			return {
				...state,
				loading: false,
			};
		case EDIT_AP_GROUP_SSID:
			return {
				...state,
				loading: false,
			};
		case ADD_AP_GROUP_SSID_COMPLETE:
			return {
				...state,
				loading: false,
				addApGroupSSIDResp: action.payload,
			};
		case EDIT_AP_GROUP_SSID_COMPLETE:
			return {
				...state,
				loading: false,
				editApGroupSSIDData: action.payload,
			};
		case DELETE_AP_GROUP_SSID_SUCCESS: {
			return {
				...state,
				deleteSuccessMessage: action.payload,
			};
		}
		case DELETE_AP_GROUP_SSID_FAIL: {
			return {
				...state,
				deleteFailMessage: action.payload,
			};
		}
		case RESET_ADD_AP_GROUP_SSID:
			return {
				...state,
				loading: false,
				editApGroupSSID: false,
				editRow: null,
				deleteSuccessMessage: null,
				deleteFailMessage: null,
				editApGroupSSIDData: null,
				addApGroupSSIDResp: null,
			};
		default:
			return state;
	}
};
export const apGroupSsidTriggerReducer = (
	state = { apGroupSsidTrigger: false },
	action
) => {
	switch (action.type) {
		case AP_GROUP_SSID_ADD_TRIGGER:
			return {
				...state,
				apGroupSsidTrigger: action.payload,
			};
		default:
			return state;
	}
};
